export default __webpack_public_path__ + "static/media/collection-logo-1.1cbb1161.png";